<template>
  <proa-card flat class="invalid-token-card">
    <div class="content-wrapper">
      <router-link :to="{ name: 'root' }" class="logo">
        <img :src="require('@/assets/images/logo.png')"/>
      </router-link>
      <div class="font-weight-w6 mb-4 pb-2">{{ $t('pages.inviteUser.invalidTokenCard.title') }}</div>
      <div class="text-pre-wrap">{{ $t('pages.inviteUser.invalidTokenCard.body') }}</div>
    </div>
  </proa-card>
</template>

<script>
export default {
  name: 'InvalidTokenCard'
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.invalid-token-card {
  width: 100%;

  @include mq(sm) {
    width: 400px;
  }
}

.content-wrapper {
  padding: 40px 50px;
  text-align: center;

  .logo {
    display: block;
    margin-bottom: 40px;

    img {
      width: 150px;
    }
  }
}
</style>
